const parse = (createdAt: string) => {
  const date = new Date(createdAt)
  return Number.isNaN(date.getTime()) ? null : date
}

const sameDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate()

/**
 * The moment of the event in the row, as short as it can be read: the time
 * for today, the day and time before that, and the year once it is another
 * year. Formatted by the locale, in the viewer's time zone.
 */
export function formatEventTime(
  createdAt: string,
  locale: string,
  now: Date = new Date()
): string {
  const date = parse(createdAt)
  if (!date) {
    return ''
  }

  if (sameDay(date, now)) {
    return new Intl.DateTimeFormat(locale, {
      hour: 'numeric',
      minute: '2-digit'
    }).format(date)
  }

  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    ...(date.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' }),
    hour: 'numeric',
    minute: '2-digit'
  }).format(date)
}

/** The full date and time, for the tooltip and assistive technology. */
export function formatEventTimeFull(createdAt: string, locale: string): string {
  const date = parse(createdAt)
  if (!date) {
    return ''
  }

  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'long',
    timeStyle: 'short'
  }).format(date)
}
